<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование пользователя" : "Добавление пользователя"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            :persistent-hint='true'
            v-model='item.name'
            label='Имя пользователя'
            hint='Введите ФИО пользователя'
          )
        v-flex(xs12 sm6)
          s-phone-input(
            :error='errors.has("phone")'
            :error-messages='errors.first("phone")'
            v-model='item.phone'
            label='Телефон'
          )
        v-flex(xs12 sm6)
          v-text-field(
            :error='errors.has("email")'
            :error-messages='errors.first("email")'
            :rules='[$rules.email]'
            v-model='item.email'
            label='Электронная почта'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='onSave'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id', 'organizationId'],

  data: () => ({
    item: {}
  }),

  async created() {
    if (this.id) {
      try {
        this.item = (await this.fetchSingle({ id: this.id })).data
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки пользователя')
      }
    } else {
      this.item.organization_id = this.organizationId
    }
  },

  methods: {
    async onSave() {
      if (this.isLoading) return

      try {
        let { id, item } = this

        if (id) {
          await this.update({
            data: item,
            id
          })
        } else {
          await this.create({ data: item })
        }

        this.$root.showSnack('Пользователь сохранен')
        this.$router.push({ name: 'Partners.Organizations' })
      } catch (e) {
        this.$root.showSnack('Ошибка сохранения')
        this.$showServerErrors(e)
      }
    },

    ...mapActions('partners/users', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    ...mapGetters('partners/users', ['isLoading'])
  }
}
</script>
